// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"127":"2bf9961930046da0","2090":"de445359ecddbb8a","3502":"44ec69d4c7cbe7eb","9203":"53a9ca7da19bc023"}[chunkId] + ".js";
};